import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from 'src/App';
import { SplashScreen } from 'src/components/loading-screen';

const rootElement = document.getElementById('root');

createRoot(rootElement).render(
  <Suspense fallback={<SplashScreen />}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Suspense>
);
